/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function Duplicate({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" clipPath="url(#Duplicate_svg__a)"><path d="M7.1.4a.6.6 0 0 1 0 1.2h-1a.4.4 0 0 0-.4.4v.5a.6.6 0 0 1-1.2 0V2A1.6 1.6 0 0 1 6.1.4h1ZM13.1.4a.6.6 0 1 0 0 1.2h1c.22 0 .4.18.4.4v.5a.6.6 0 1 0 1.2 0V2A1.6 1.6 0 0 0 14.1.4h-1ZM15.7 9.35a.6.6 0 0 0-1.2 0v1a.4.4 0 0 1-.4.4h-.5a.6.6 0 1 0 0 1.2h.5a1.6 1.6 0 0 0 1.6-1.6v-1ZM9.3.4a.6.6 0 0 0 0 1.2h1.8a.6.6 0 0 0 0-1.2H9.3ZM15.1 4.1a.6.6 0 0 1 .6.6v2.2a.6.6 0 0 1-1.2 0V4.7a.6.6 0 0 1 .6-.6ZM6.85 7.125a.6.6 0 1 0-1.2 0V9.15H3.625a.6.6 0 0 0 0 1.2H5.65v2.025a.6.6 0 1 0 1.2 0V10.35h2.025a.6.6 0 1 0 0-1.2H6.85V7.125Z" /><path fillRule="evenodd" d="M3 3.9A2.6 2.6 0 0 0 .4 6.5V13A2.6 2.6 0 0 0 3 15.6h6.5a2.6 2.6 0 0 0 2.6-2.6V6.5a2.6 2.6 0 0 0-2.6-2.6H3ZM1.6 6.5A1.4 1.4 0 0 1 3 5.1h6.5a1.4 1.4 0 0 1 1.4 1.4V13a1.4 1.4 0 0 1-1.4 1.4H3A1.4 1.4 0 0 1 1.6 13V6.5Z" clipRule="evenodd" /></g><defs><clipPath id="Duplicate_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;